import { render } from "./EdoDocumentFlowDetails.vue?vue&type=template&id=f4b66c9c&scoped=true"
import script from "./EdoDocumentFlowDetails.vue?vue&type=script&lang=js"
export * from "./EdoDocumentFlowDetails.vue?vue&type=script&lang=js"

import "./EdoDocumentFlowDetails.vue?vue&type=style&index=0&id=f4b66c9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b66c9c"]])

export default __exports__